import useDownloadTemplate from '@/pages/moves/upload/hooks/useDownloadTemplates';
import React from 'react';

import { Button, Text } from 'vkit/lib/components';

import { FormDataSteps } from '../../enum/FormDataSteps';
import { TFormData } from '../../types/FormData.type';

interface TemplateDownloadProps {
  formData: TFormData;
  setData: (key: string, value: any) => void;
  triggerToast: Function;
}

const TemplateDownload: React.FC<TemplateDownloadProps> = ({ formData, setData, triggerToast }) => {
  const { loading, canDownload, downloadTemplate } = useDownloadTemplate();

  const isDownloadEnabled = React.useMemo(() => canDownload(formData), [canDownload, formData]);

  const handleDownload = React.useCallback(async (): Promise<void> => {
    const success = await downloadTemplate(formData);

    if (success) {
      setData(FormDataSteps.templateDownloaded, true);
    } else {
      triggerToast('Oops!', 'Falha ao baixar arquivo.', 'error');
    }
  }, [downloadTemplate, formData, setData, triggerToast]);

  return (
    <div>
      <Text value='Clique no botão abaixo para obter o arquivo modelo' title padding='0 0 18px' />
      <Button
        color='colorDefault'
        label='Download do arquivo modelo'
        onClick={() => handleDownload()}
        disabled={!isDownloadEnabled}
        loading={loading}
      />
    </div>
  );
};

export default TemplateDownload;
